import React from "react";
import University from "../Menabout/University";
import Header from "../headerone/Main";
import Bredcom from "../Bredcom/Main";
import Scholarship from "../menhome/Scholarship";
import Frequently from "../menhome/Frequently";
import Campus from "../Menabout/Campus";
import Testimonial from "../menhome/Testimonial";
import Brand from "../menhomethree/Brand";
import Search from "../menhome/Search";
import Admission from "../menhome/Admission";
import LeadershipSection from "../Menabout/LeadershipSection";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom title="Home" subtitle="About Us" />
        <University />
        <LeadershipSection />
        {/* <Scholarship/> */}
        {/* <Frequently/> */}
        <Campus />
        <Admission />
        {/* <Search />
        <Testimonial /> */}
        <br/>
        {/* <Brand/> */}
      </section>
    </>
  );
}

export default Main;
